import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {StockistService} from '../../shared/services/stockist.service';

@Component({
    selector: 'app-my-wallet',
    templateUrl: './my-wallet.component.html',
    styleUrls: ['./my-wallet.component.scss']
})
export class MyWalletComponent implements OnInit {
    userData: any;
    totalAmount: any;

    constructor(private router: Router,
                private stockistService: StockistService) {
    }

    ngOnInit(): void {
        this.getDetail();
    }

    getDetail() {
        this.stockistService.selfDetail().subscribe(data => {
            if (data) {
                this.userData = data;
                const walletAmount = (this.userData && this.userData['wallet_amount']) ? parseFloat(this.userData['wallet_amount']) : 0;
                const activationAmount = (this.userData && this.userData['activation_amount']) ? parseFloat(this.userData['activation_amount']) : 0;
                this.totalAmount = walletAmount + activationAmount;
            }
        });
    }

    goTo(url) {
        this.router.navigateByUrl(url);
    }
}
